var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.user)?_c('b-container',{staticClass:"custom-container p-0 pt-5 pb-5"},[_c('div',{staticClass:"page-title pt-5 mb-4"},[_vm._v("Welcome "+_vm._s(_vm.user.first_name)+"!")])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }